import { Injectable } from '@angular/core';
import { AsyncMessage, MicroFEService, MicroFrontendHttpOptions, MicrofrontendSessionState } from 'pssfe-micro-fe-service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { MfeUtilityService } from './mfe-utility.service';

@Injectable({
  providedIn: 'root'
})
export class VafCommonService {

  constructor(private _microFeSrv: MicroFEService, private _mfeUtilitySrv: MfeUtilityService, public transalte: TranslateService) {
  }
  //STARTUP
  public async startup() {
    return new Promise(async (resolve) => {
      let stylesBaseUri = document.baseURI;
      const urlSearchParams = new URLSearchParams(window.location.search);
      let additionalStyleFolder = urlSearchParams.get("additionalStyleFolder");
      if (stylesBaseUri.indexOf("/fe-") != -1)
        stylesBaseUri = stylesBaseUri.substring(0, stylesBaseUri.indexOf("/fe-") + 1);
      this._microFeSrv.updateStylesByEnvironment((this._mfeUtilitySrv.getEnvironment() as string).toUpperCase().indexOf('STAGE') != -1 ? 'stage' : (this._mfeUtilitySrv.getEnvironment() as string).toUpperCase().indexOf('PROD') != -1 ? 'prod' : 'test', additionalStyleFolder);
      resolve(true);
    });
  }

  //--- HTTP ---//
  //GLOBAL
  //get sezioni api request
  public async getSezioni(sectionId: string) {
    return new Promise(async (resolve, reject) => {
      let sessionState: MicrofrontendSessionState = await this._microFeSrv.getSessionState();
      let payload = {
        "idRuolo": sessionState?.role?.id,
        "idModulo": sectionId,
      }
      this._microFeSrv.sendCoreHttpRequest({
        url: `${this._mfeUtilitySrv.links.apigateway}api/getSezioni`, method: 'post', options: {
          body: payload
        }
      }).then((res) => {
        if (res.response) {
          if (res.response.httpError) {
            reject(res.response.httpError)
          } else {
            resolve(res.response.result);
          }
        } else {
          reject(new HttpErrorResponse({}))
        }
      }).catch((err) => {
        reject(err);
      })
    });
  }
  //--- END HTTP ---//


  //--- end http ---//

  //--- global --//
  //currencyTransform
  public currencyTransform(event) {
    if (event != '' && event != undefined && event != null) {
      if (/^[0-9,.]*$/.test(event)) {
        event = event.toString().replace(/\D/g, "");
        if (['en-US'].includes(navigator.languages[0])) {
          //add dot if required 
          if (event.length > 2) {
            event = event.substring(0, event.length - 2) + "." + event.substring(event.length - 2);
            event = event.toString().replace(/,\./g, ",").replace(/\.,/g, ".");
          }
          if (event.includes(".")) {
            let decimal = event.substring(0, event.indexOf("."));
            decimal = parseInt(decimal).toLocaleString('en-US');
            event = decimal + event.substring(event.indexOf("."), event.length);
          }
        } else {
          //add comma if required 
          if (event.length > 2) {
            event = event.substring(0, event.length - 2) + "," + event.substring(event.length - 2);
            event = event.toString().replace(/,\./g, ",").replace(/\.,/g, ",");
          }
          if (event.includes(",")) {
            let decimal = event.substring(0, event.indexOf(","));
            decimal = parseInt(decimal).toLocaleString('it-IT');
            event = decimal + event.substring(event.indexOf(","), event.length);
          }
        }

      } else {
        event = event.slice(0, -1);
      }
    } else {
      event = '';
    }
    return event;
  }
  public getValueCurrencyTransform(amount: string): number {
    let result: number;
    if (amount == null || amount == undefined || amount == '')
      result = null;
    else {
      let tmpAmount: string = JSON.parse(JSON.stringify(amount));
      if (['en-US'].includes(navigator.languages[0])) {
        tmpAmount = tmpAmount.replace(/,/g, '');
        result = parseFloat(tmpAmount);
      } else {
        tmpAmount = tmpAmount.replace(/\./g, '').replace(/,/g, '.');
        result = parseFloat(tmpAmount);
      }
    }
    return result;
  }
  public getBeDate(dt: Date, type: 'DATE' | 'DATETIME'): string {
    let newDt: string, dtDate: Date;
    if (dt) {
      dtDate = new Date(dt);
      newDt = dtDate.getFullYear() + "-" +
        ("0" + (dtDate.getMonth() + 1)).slice(-2) + "-" +
        ("0" + dtDate.getDate()).slice(-2) +
        (type == 'DATETIME' ? "T" + ("0" + dtDate.getHours()).slice(-2) + ":" + ("0" + dtDate.getMinutes()).slice(-2) : '');
      /*if (['en-US'].includes(navigator.languages[0])) { 
        newDt = dtDate.getFullYear() + "-" +
          ("0" + dtDate.getDate()).slice(-2) + "-" +
          ("0" + (dtDate.getMonth() + 1)).slice(-2) + "-" +
          (type == 'DATETIME' ? "T" + ("0" + dtDate.getHours()).slice(-2) + ":" + ("0" + dtDate.getMinutes()).slice(-2) : '');
      } else {
        newDt = ("0" + dtDate.getDate()).slice(-2) + "-" +
          ("0" + (dtDate.getMonth() + 1)).slice(-2) + "-" +
          dtDate.getFullYear() + (type == 'DATETIME' ? "T" + ("0" + dtDate.getHours()).slice(-2) + ":" + ("0" + dtDate.getMinutes()).slice(-2) : '');
      }*/
    }
    return newDt != null && newDt != undefined && newDt != '' ? newDt : null;
  }
  public getFEDate(dt: Date, type: 'DATE' | 'DATETIME'): string {
    let newDt: string, dtDate: Date;
    if (dt) {
      dtDate = new Date(dt);
      if (['en-US'].includes(navigator.languages[0])) {
        newDt =
          ("0" + (dtDate.getMonth() + 1)).slice(-2) + "/" +
          ("0" + dtDate.getDate()).slice(-2) + "/" +
          dtDate.getFullYear() +
          (type == 'DATETIME' ? (" " + ("0" + dtDate.getHours()).slice(-2) + ":" + ("0" + dtDate.getMinutes()).slice(-2)) : '');
      } else {
        newDt =
          ("0" + dtDate.getDate()).slice(-2) + "/" +
          ("0" + (dtDate.getMonth() + 1)).slice(-2) + "/" +
          dtDate.getFullYear() +
          (type == 'DATETIME' ? (" " + ("0" + dtDate.getHours()).slice(-2) + ":" + ("0" + dtDate.getMinutes()).slice(-2)) : '');
      }
    }
    return newDt != null && newDt != undefined && newDt != '' ? newDt : null;
  }
  public async getDateFormatString(): Promise<string> {
    return new Promise((resolve) => {
      this.transalte.get('toll').subscribe((labels) => {
        resolve(['en-US'].includes(navigator.languages[0]) ? labels['enDateFormat'] : labels['itDateFormat']);
      })
    })

  }
  public async getDateTimeFormatString(): Promise<string> {
    return new Promise((resolve) => {
      this.transalte.get('toll').subscribe((labels) => {
        resolve(['en-US'].includes(navigator.languages[0]) ? labels['enDateTimeFormat'] : labels['itDateTimeFormat']);
      })
    })
  }

  public buildQueryParams(properties: Array<{ key: string, value: any }>) {
    let qp: string = '?';
    properties = properties.filter((p) => { return p.value != null && p.value != undefined && p.value != '' });
    properties.forEach((p, index) => {
      qp = qp + (index == 0 ? (p.key + '=' + p.value) : ('&' + p.key + '=' + p.value));
    })
    return qp;
  }
  public async awaitTimeout(timeoutMs: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true);
      }, timeoutMs)
    })
  }
  //downloadFileFromBase64
  public downloadCsvFileFromBase64(response: HttpResponse<any>) {
    // Ottieni il nome del file dall'header Content-Disposition
    const contentDisposition = response?.headers && response.headers['content-disposition'] ? response.headers['content-disposition'] : null;
    let filename = 'downloaded_file';
    if (contentDisposition) {
      const matches = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/);
      if (matches?.length > 1) {
        filename = decodeURIComponent(matches[1].replace(/['"]/g, '')); // Decodifica il nome
      }
    }

    // Crea un URL per il blob e scaricalo
    const blob = new Blob([response.body!], { type: response.body!.type });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Rilascia l'URL del blob dalla memoria
    window.URL.revokeObjectURL(url);
  }
  //--- end global (isBackOffice lo mettiamo in config utente) ---//
}
